module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "error-page"
  }, [_c('h2', {
    staticClass: "headline text-yellow"
  }, [_vm._v("404")]), _vm._v(" "), _c('div', {
    staticClass: "error-content"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n            We could not find the page you were looking for. Meanwhile, you\n            may "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("return to dashboard")]), _vm._v(" or try\n            using the search form.\n          ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('i', {
    staticClass: "fa fa-warning text-yellow"
  }), _vm._v(" Oops! Page not found.\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fdc0621!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comman/Error.vue
// module id = 840
// module chunks = 0